// extracted by mini-css-extract-plugin
module.exports = {"image":"_1ZJzw","icon":"_2x9zt"};